export const MARKET_QC = "QC";
export const MARKET_ON = "ON";

export function normalizeLocale(locale) {
  return locale && locale.indexOf("fr") === 0 ? "fr" : "en";
}

export function getCurrentMarket(country) {
  return country || localStorage.getItem("countryCode") || MARKET_QC;
}

export function getConsignmentInventory(market) {
  return market === MARKET_ON ? "PI" : "IP";
}

export function getBoardInventory(market) {
  return market === MARKET_ON ? "LCBO" : "SAQ";
}

export function getDefaultAvailability(market) {
  if (market === MARKET_ON) {
    return ["LCBO", "PI", "MERCH_TORONTO"];
  }

  return ["IP", "SAQ", "Brouhh", "MERCH_MTL", "BERGEVILLE"];
}

// The `inventory` query param serves two very different purposes:
//  - on the boutique pages it names a single retail store (STORE_MTL,
//    STORE_QC, STORE_TORONTO) and puts the page in "shop" mode;
//  - on the agency products page it carries the *warehouse* selection
//    (IP, SAQ, Brouhh, ...) so the entrepôt filter survives pagination,
//    language/region/tax switches and shared URLs.
// Only the first meaning may switch the page into shop mode, so every
// "is this the boutique?" test must go through this helper instead of
// checking that `inventory` is merely present.
export function isBoutiqueInventory(inventory) {
  const codes = Array.isArray(inventory) ? inventory : [inventory];
  return codes.some((code) => typeof code === "string" && code.indexOf("STORE_") === 0);
}

export function getSocialLinks(market) {
  return {
    instagram:
      market === MARKET_ON
        ? "https://www.instagram.com/boires.on/"
        : "https://www.instagram.com/boires.ca/",
    facebook:
      market === MARKET_ON
        ? "https://www.facebook.com/boires.on/"
        : "https://www.facebook.com/boires.ca/",
  };
}

export function parseAvailabilityStatusQuery(show) {
  switch (show) {
    case "AVAILABLE":
      return ["AVAILABLE"];
    case "UPCOMING":
      return ["UPCOMING"];
    case "AVAILABLE_UPCOMING":
    default:
      return ["AVAILABLE", "UPCOMING"];
  }
}

export function availabilityStatusToQuery(statuses) {
  if (statuses == null || statuses.length === 0) {
    return null;
  }

  const hasAvailable = statuses.indexOf("AVAILABLE") > -1;
  const hasUpcoming = statuses.indexOf("UPCOMING") > -1;

  if (hasAvailable && hasUpcoming) {
    return "AVAILABLE_UPCOMING";
  }

  if (hasAvailable) {
    return "AVAILABLE";
  }

  if (hasUpcoming) {
    return "UPCOMING";
  }

  return statuses[0] || null;
}

export function getEmbeddedNewsletterCustomerType(market) {
  return market === MARKET_ON ? "INDIVIDUAL_ON" : "INDIVIDUAL_QC";
}

export function getNewsletterMarket(customerType, fallbackMarket) {
  if (customerType && customerType.indexOf("_ON") > -1) {
    return MARKET_ON;
  }

  if (customerType && customerType.indexOf("_QC") > -1) {
    return MARKET_QC;
  }

  return fallbackMarket || MARKET_QC;
}
